import { Star, Quote } from "lucide-react";
import { GoogleIcon } from "./Icons";

const fmt = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return Number.isNaN(dt.getTime()) ? d : dt.toLocaleDateString("tr-TR", { month: "long", year: "numeric" });
};

export const Stars = ({ n }) => (
  <span className="flex gap-0.5" aria-label={`${n} / 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-4 w-4 ${i <= n ? "fill-gold text-gold" : "text-gold/30"}`} strokeWidth={1.5} />
    ))}
  </span>
);

export const ReviewCard = ({ r, testId }) => (
  <figure className="card-lux relative flex h-full flex-col p-6 sm:p-7" data-testid={testId}>
    <Quote className="absolute right-6 top-6 h-8 w-8 text-gold/25" strokeWidth={1.4} aria-hidden="true" />
    <Stars n={r.rating} />
    <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-ink/75">“{r.text}”</blockquote>
    <figcaption className="mt-6 flex items-center gap-3 border-t border-gold/15 pt-4">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-950 text-sm font-semibold text-gold-light">{r.name.charAt(0)}</span>
      <span className="min-w-0">
        <span className="block font-semibold text-emerald-950">{r.name}</span>
        <span className="block truncate text-xs text-ink/50">{[r.service, fmt(r.date)].filter(Boolean).join(" · ")}</span>
      </span>
      {r.source === "google" && (
        <span className="ml-auto inline-flex shrink-0 items-center gap-1 rounded-full bg-cream px-2 py-1 text-[10px] font-medium text-ink/60 ring-1 ring-gold/20" data-testid="review-google-label">
          <GoogleIcon className="h-3 w-3" /> Google yorumu
        </span>
      )}
    </figcaption>
  </figure>
);
